import { atom } from 'jotai';
import {
  MessageDbInteractiveList,
  QRInteractiveReplyButtonsType,
  QuickReplyAtomTypeForTextOrMediaType,
  QuickReplyMsgType,
} from '../types/quick-reply';
import { AiBotType, AIFeaturePermissionResponse, GetCallConfigurationResponse } from '../../../typings';
import { MentionMeta, ReminderNoteState } from '../types/reminder';

export const previewQuickReplyStateAtom = atom<boolean>(false);
export const createQuickReplySelectedTypeAtom = atom<QuickReplyMsgType>(QuickReplyMsgType.TEXT_OR_MEDIA);
export const createQuickReplyTextOrMediaAtom = atom<QuickReplyAtomTypeForTextOrMediaType>(null);
export const createQuickReplyInteractiveReplyButton = atom<QRInteractiveReplyButtonsType>({
  body: {
    text: '',
  },
  header: {
    type: 'text',
    text: '',
  },
  footer: {
    text: '',
  },
  buttons: [],
});

export const createQuickReplyInteractiveListAtom = atom<MessageDbInteractiveList>({
  body: {
    text: '',
  },
  header: {
    type: 'text',
    text: '',
  },
  button: '',
  footer: {
    text: '',
  },
  sections: [],
});

export const quickRepliesPopupVisibleAtom = atom<boolean>(false);

export const chatInputTextAtom = atom('');

export const aiFeaturePermissionAtom = atom<AIFeaturePermissionResponse | null>(null);

export const defaultBotSetupAtom = atom<AiBotType | null>(null);
export const fmInputFooterPreviewTextAtom = atom<string>('');
export const fmInputHeaderTextPreviewTextAtom = atom<string>('');

export const activeFMPreviewInputAtom = atom<boolean>(false);

export const callSettingsAtom = atom<GetCallConfigurationResponse | null>(null);

export const mentionsAtom = atom<MentionMeta[]>([]);

export const reminderNoteAtom = atom<ReminderNoteState>({
  open: false,
  data: null,
});

export const scheduledMessageBannerAtom = atom<{ timestamp: number; timezone?: string | null } | null>(null);

export type EditingMessageState = {
  messageId: string;
  originalText: string;
  originalFileUrl?: string;
  isFrictionless?: boolean;
  frictionlessType?: string;
} | null;

export const editingMessageAtom = atom<EditingMessageState>(null);
